import { useCallback, useRef, useImperativeHandle, forwardRef } from 'react'
import Box from '@mui/material/Box'
import Terminal from '../../../../shared/components/shell/Terminal'

const SessionTerminal = forwardRef(function SessionTerminal(
  { sessionId, sendInput, sendResize, setTerminal, visible },
  ref,
) {
  const terminalRef = useRef(null)

  useImperativeHandle(ref, () => ({
    fit: () => {
      if (terminalRef.current?.fit) {
        terminalRef.current.fit()
      }
    },
    focus: () => {
      if (terminalRef.current?.focus) {
        terminalRef.current.focus()
      }
    },
    getTerminal: () => terminalRef.current?.getTerminal?.(),
  }), [])

  const handleData = useCallback((data) => {
    sendInput(sessionId, data)
  }, [sessionId, sendInput])

  const handleResize = useCallback((cols, rows) => {
    sendResize(sessionId, cols, rows)
  }, [sessionId, sendResize])

  const handleReady = useCallback((terminal) => {
    setTerminal(sessionId, terminal)
  }, [sessionId, setTerminal])

  return (
    <Box sx={{ display: visible ? 'flex' : 'none', flex: 1, minHeight: 0 }}>
      <Terminal
        ref={terminalRef}
        onData={handleData}
        onResize={handleResize}
        onReady={handleReady}
      />
    </Box>
  )
})

export default SessionTerminal
